
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreement/contact",
      function () {
        return require("private-next-pages/agreement/contact.tsx");
      }
    ]);
  